// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__258io","label":"CategoryService_label__1F0z2","location":"CategoryService_location__3QPp_"};